import React from 'react'
import { Button, Form, Alert, Spinner } from 'react-bootstrap'
import styled from 'styled-components'

const WMSControlPanelContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background: rgba(26, 26, 26, 0.8);
  border-radius: 8px;
  padding: 12px;
  width: 300px;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
`

const SignInSection = styled.div`
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

interface WmsPanelProps {
  showGEGDPanel: boolean
  isWmsAuthenticated: boolean
  connectId: string
  setConnectId: (value: string) => void
  username: string
  setUsername: (value: string) => void
  password: string
  setPassword: (value: string) => void
  handleWmsSignIn: () => void
  handleWmsSignOut: () => void
  isLoadingCapabilities: boolean
  errorMessage: string | null
  setShowGEGDPanel: (value: boolean) => void
}

const WmsPanel: React.FC<WmsPanelProps> = ({
  showGEGDPanel,
  isWmsAuthenticated,
  connectId,
  setConnectId,
  username,
  setUsername,
  password,
  setPassword,
  handleWmsSignIn,
  handleWmsSignOut,
  isLoadingCapabilities,
  errorMessage,
  setShowGEGDPanel,
}) => {
  if (!showGEGDPanel) return null

  return (
    <WMSControlPanelContainer>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">GEGD Sign In</h5>
        <Button
          variant="link"
          size="sm"
          className="text-white p-0"
          onClick={() => setShowGEGDPanel(false)}
        >
          <i className="bi bi-x-lg"></i>
        </Button>
      </div>

      <SignInSection>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Connect ID</Form.Label>
            <Form.Control
              type="text"
              size="sm"
              value={connectId}
              onChange={(e) => setConnectId(e.target.value)}
              className="bg-dark text-light border-secondary"
              disabled={isWmsAuthenticated}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              size="sm"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="bg-dark text-light border-secondary"
              disabled={isWmsAuthenticated}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              size="sm"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-dark text-light border-secondary"
              disabled={isWmsAuthenticated}
            />
          </Form.Group>

          <div className="d-grid">
            {!isWmsAuthenticated ? (
              <Button
                variant="primary"
                size="sm"
                onClick={handleWmsSignIn}
                disabled={isLoadingCapabilities}
              >
                {isLoadingCapabilities ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                    Signing In...
                  </>
                ) : (
                  'Sign In to GEGD'
                )}
              </Button>
            ) : (
              <Button variant="outline-danger" size="sm" onClick={handleWmsSignOut}>
                Sign Out
              </Button>
            )}
          </div>
        </Form>
      </SignInSection>

      {errorMessage && (
        <Alert variant="danger" className="mt-2 p-2 small">
          {errorMessage}
        </Alert>
      )}
    </WMSControlPanelContainer>
  )
}

export default WmsPanel
